<template>
  <div class="row m-0">
    <div class="col-sm-4 content-wrapper">
    <div class="address-info">
      <div class="address-text">{{ address.address }}</div>
      <div class="address-city">
        <strong>City:</strong> {{ address.city }} | <strong>Post Code:</strong> {{ address.post_code }}
      </div>
      <div class="address-dates">

        <span><strong>From:</strong> {{ dateFormatter(address.from_date) }}</span>
        <span><strong>To:</strong> {{ dateFormatter(address.to_date) }}</span>
      </div>
      </div>
    </div>

    <div class="col-sm-8 content-wrapper">
      <div class="form-group row">
        <el-button
            type="primary"
            size="small"
            @click="setIsShowStatus">
          {{ isShowStatus ? 'Hide Status' : 'Show Status' }}
        </el-button>
      </div>

      <div class="form-group row">
        <general-comments
            :comments="comment"
            :emailAddress="emailAddress"
            :applicantId="applicantId"
            :statusable_type="statusable_type"
            :statusable_id="statusable_id"
            :showSteps="false"
            :steps="this.steps"
            @status-saved="onChildStatusSaved"
            v-if="isShowStatus"
        />
      </div>
      <div class="form-group row">
        <comments-steps-tree
            :steps="steps"
            :history="treeHistory"
            :emailAddress="emailAddress"
            @node-delete="deleteNode"
            @node-edit="editNode"
            @comment-updated="handleCommentUpdate"
        />
      </div>
      <div class="form-group row">
        <comments-list v-if="showcommentToEdit"
                       :comment="commentToEdit"
                       :applicantId="applicantId"
                       :emailAddress="emailAddress"
                       @close-comment-listing="closeComment"
                       :steps="this.steps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  dateFormatter
} from "@Views/Screening/utility/common";
import {_status, oralSteps, writtenSteps} from "@Views/Screening/utility/constant";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";
import {Comment} from "@Views/Screening/utility/apiAgent";

export default {
  name: "AddressComments",
  props: {
    address: {
      type: Object
    },
    applicantId: {
      type: Number
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number
    },
    emailAddress: {
      type: String
    },
    comment: {
      type: Array
    }
  },
  data() {
    return {
      steps: [],
      showcommentToEdit: false,
      commentToEdit: {},
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps,
      isShowStatus: true
    }
  },
  created() {
    this.setStepsOnInitialization();
  },
  watch: {
    comment: {
      handler() {
        this.setStepsOnInitialization();
      },
      deep: true
    },
    statusable_id() {
      this.setStepsOnInitialization();
    }
  },
  computed: {
    treeHistory() {
      return { applicant_id: this.applicantId };
    }
  },
  methods: {
    dateFormatter,
    updateCommentSteps,
    onChildStatusSaved(payload){
      try{
        const { comment, uploadedFiles } = payload || {};
        if (!comment) return;
        this.updateCommentSteps(comment, false, uploadedFiles || []);
      }catch(e){
        console.error(e);
      }
    },
    handleCommentUpdate(updatedChild) {
      // Update the local steps array with the updated comment data
      this.steps.forEach(step => {
        const childIndex = step.children?.findIndex(child => child.id === updatedChild.id);
        if (childIndex !== -1 && childIndex !== undefined) {
          // Update the specific child with fresh data
          this.$set(step.children, childIndex, {
            ...step.children[childIndex],
            action_comment: updatedChild.action_comment,
            created_at: updatedChild.created_at,
            include_in_report: !!updatedChild.include_in_report,
            applicant_files: updatedChild.applicant_files || []
          });
        }
      });
      
      // Emit to parent component with correct payload structure
      this.$emit('status-updated', {
        id: updatedChild.id,
        statusable_id: updatedChild.statusable_id || this.address.id,
        statusable_type: updatedChild.statusable_type || this.address.statusable_type,
        action_comment: updatedChild.action_comment,
        created_at: updatedChild.created_at,
        include_in_report: !!updatedChild.include_in_report,
        applicant_files: updatedChild.applicant_files || [],
        screening_endorsement: updatedChild.screening_endorsement
      });
    },
    deleteNode(commentObj) {
      if (!window.confirm("Are you sure you want to delete this action?")) {
        return;
      }
      const commentId = commentObj.id;
      Comment.deleteComment(commentId)
          .then(() => {
            let indexToRemove = this.steps.findIndex(step =>
                step.children?.some(child => child.id === commentId)
            );
            if (indexToRemove !== -1) {
              this.steps[indexToRemove].children = this.steps[indexToRemove].children.filter(child => child.id !== commentId);
              if (this.steps[indexToRemove].children.length === 0) {
                this.steps.splice(indexToRemove, 1);
              }
            }
            this.$toastr.s("Comment deleted successfully!");
            this.$emit('status-deleted', { id: commentId, type: this.statusable_type, statusable_id: this.statusable_id });
          })
          .catch(error => {
            this.$toastr.e("Failed to delete comment.");
            console.error(error);
          });
    },
    editNode(event) {
      this.commentToEdit = {};
      this.$set(this.commentToEdit, 'id', event.data.children[0].id);
      this.$set(this.commentToEdit, 'action_comment', event.data.children[0].action_comment);
      this.$set(this.commentToEdit, 'status', event.data.children[0].type);
      this.$set(this.commentToEdit, 'applicant_files', event.data.children[0].applicant_files);
      this.$set(this.commentToEdit, 'statusable_id', event.data.children[0].statusable_id);
      this.$set(this.commentToEdit, 'statusable_type', event.data.children[0].statusable_type);
      this.showcommentToEdit = true;
    },
    closeComment(event) {
      this.commentToEdit = {};
      this.showcommentToEdit = event;
    },
    setStepsOnInitialization() {
      this.steps.splice(0);
      const comments = Array.isArray(this.comment) ? this.comment : [];
      for (const _comment of comments) {
        const o = {
          id : _comment.id,
          created_at: _comment.created_at,
          action_comment: _comment.action_comment,
          include_in_report: !!_comment.include_in_report,
          status: _comment.status,
          applicant_files: _comment.applicant_files,
          statusable_id : _comment.statusable_id,
          statusable_type : _comment.statusable_type,
          screening_endorsement : _comment.screening_endorsement ?? {}
        };
        this.updateCommentSteps(o, true);
      }
    },
    setIsShowStatus() {
      this.isShowStatus = !this.isShowStatus;
    }
  }
}
</script>

<style scoped>
.address-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #28a745;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  max-width: 400px;
}

.address-text {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.address-city {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
}

.address-dates {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}

.address-dates span {
  padding: 3px 0;
}

</style>
